declare let projectData;
declare let navigationData;
declare let voting_enabled;
declare let category_switch;
declare let all_voted;


export const getProjectData = () => {
    if (typeof projectData != "undefined")
        return projectData;
    return {}
};

export const getNavigationData = () => {
    if (typeof navigationData != "undefined")
        return navigationData;
    return {}
};

export const getVotingEnabledData = () => {
    if (typeof voting_enabled != "undefined")
        return voting_enabled;
    return 0
};

export const getCategorySwitch = () => {
    if (typeof category_switch != "undefined")
        return category_switch;
    return 0
};

export const getAllVoted = () => {
    if (typeof all_voted != "undefined")
        return all_voted;
    return 0
};


